module.exports = __webpack_public_path__ + "img/hamochi_happy.f3cabb4b.png";